<div class="analytics-wrapper">
  <!-- Print Only Header -->
  <div class="print-only-header">
    <div class="print-brand">
      <img src="assets/images/Logo.png" class="print-logo" alt="RTT Logo">
      <div class="brand-text">
        <h1>RealTimeTrac</h1>
        <p>Advanced Delivery Analytics</p>
      </div>
    </div>
    <div class="report-meta">
      <div class="meta-item">
        <span class="meta-label">Report Type:</span>
        <span class="meta-value">Executive Performance Summary</span>
      </div>
      <div class="meta-item">
        <span class="meta-label">Period:</span>
        <span class="meta-value">{{startDate}} to {{endDate}}</span>
      </div>
      <div class="meta-item">
        <span class="meta-label">Generated:</span>
        <span class="meta-value text-tertiary">{{todayDate | date:'medium'}}</span>
      </div>
    </div>
  </div>

  <div class="page-header">
  </div>

  <div class="analytics-container">
    <!-- Status & Summary Section -->
    <div class="analytics-header-section">
      <div>
        <h2 class="page-title">Analytics Dashboard</h2>
        <p class="page-subtitle">Overview & Performance Metrics</p>
      </div>

      <div class="header-actions">
        <div class="date-range-picker">
          <div class="date-input-group">
            <label>From</label>
            <input type="date" [(ngModel)]="startDate" (change)="fetchAnalyticsData()" class="date-input"
              title="Start Date" placeholder="YYYY-MM-DD">
          </div>
          <div class="date-input-group">
            <label>To</label>
            <input type="date" [(ngModel)]="endDate" (change)="fetchAnalyticsData()" class="date-input" title="End Date"
              placeholder="YYYY-MM-DD">
          </div>
        </div>
        <div class="export-dropdown-wrapper">
          <button class="btn btn-primary" (click)="toggleExportDropdown()">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                clip-rule="evenodd" />
            </svg>
            Export Report
            <svg class="chevron-icon" [class.open]="showExportDropdown" width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div class="export-dropdown-menu" *ngIf="showExportDropdown">
            <div class="dropdown-item" (click)="exportReport('pdf')">
              <span class="item-icon pdf">PDF</span>
              <div class="item-content">
                <div class="item-title">Executive Summary</div>
                <p class="item-desc">PDF report with charts & KPIs</p>
              </div>
            </div>
            <div class="dropdown-item" (click)="exportReport('csv-drivers')">
              <span class="item-icon csv">CSV</span>
              <div class="item-content">
                <div class="item-title">Driver Performance</div>
                <p class="item-desc">Detailed spreadsheet for drivers</p>
              </div>
            </div>
            <div class="dropdown-item" (click)="exportReport('csv-orders')">
              <span class="item-icon csv">CSV</span>
              <div class="item-content">
                <div class="item-title">Order Trend Data</div>
                <p class="item-desc">Raw metrics for trend analysis</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- KPI Cards -->
    <div class="kpi-row">
      <ng-container *ngIf="!isLoading; else kpiSkeleton">
        <div class="kpi-card" *ngFor="let kpi of kpiCards">
          <div class="kpi-header">
            <div class="kpi-icon" [ngClass]="kpi.iconType">
              <svg fill="currentColor" viewBox="0 0 20 20">
                <path [attr.d]="kpi.icon" [attr.fill-rule]="kpi.icon.includes('fill-rule') ? 'evenodd' : null"
                  [attr.clip-rule]="kpi.icon.includes('clip-rule') ? 'evenodd' : null" />
              </svg>
            </div>
            <div class="kpi-trend" [ngClass]="kpi.isPositive ? 'positive' : 'negative'">
              <svg fill="currentColor" viewBox="0 0 20 20">
                <path *ngIf="kpi.isPositive" fill-rule="evenodd"
                  d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                  clip-rule="evenodd" />
                <path *ngIf="!kpi.isPositive" fill-rule="evenodd"
                  d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
                  clip-rule="evenodd" />
              </svg>
              {{kpi.trend}}%
            </div>
          </div>
          <div class="kpi-body">
            <div class="kpi-label">{{kpi.label}}</div>
            <div class="kpi-value">{{kpi.value}}</div>
          </div>
          <div class="kpi-footer">
            <div class="kpi-comparison">{{kpi.comparison}}</div>
          </div>
        </div>
      </ng-container>

      <ng-template #kpiSkeleton>
        <div class="skeleton-kpi-card" *ngFor="let i of [1,2,3,4,5,6]">
            <div class="skeleton-kpi-header">
                <div class="skeleton-block skeleton-icon-circle"></div>
                <div class="skeleton-block skeleton-trend-badge"></div>
            </div>
            <div class="skeleton-block skeleton-kpi-label"></div>
            <div class="skeleton-block skeleton-kpi-value"></div>
            <div class="kpi-footer">
                <div class="skeleton-block skeleton-kpi-footer"></div>
            </div>
        </div>
      </ng-template>
    </div>

    <!-- Charts Grid -->
    <div class="charts-grid">
      <ng-container *ngIf="!isLoading; else chartsSkeleton">
        <!-- Orders Trend -->
        <div class="chart-card large">
          <div class="chart-header">
            <div>
              <div class="chart-title">Orders Trend</div>
              <div class="chart-subtitle">{{selectedPeriod}} orders over the selected period</div>
            </div>
            <div class="chart-actions">
              <button class="chart-filter compare-btn" [class.active]="showComparison"
                (click)="toggleComparison()">
                <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="margin-right: 4px;">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
                Compare
              </button>
              <div class="action-divider"></div>
              <button class="chart-filter" [class.active]="selectedPeriod === 'Daily'"
                (click)="selectPeriod('Daily')">Daily</button>
              <button class="chart-filter" [class.active]="selectedPeriod === 'Weekly'"
                (click)="selectPeriod('Weekly')">Weekly</button>
              <button class="chart-filter" [class.active]="selectedPeriod === 'Monthly'"
                (click)="selectPeriod('Monthly')">Monthly</button>
            </div>
          </div>
          <div class="chart-body tall">
            <canvas #ordersChart></canvas>
          </div>
        </div>

        <!-- Order Status -->
        <div class="chart-card small">
          <div class="chart-header">
            <div>
              <div class="chart-title">Order Status</div>
              <div class="chart-subtitle">Distribution breakdown</div>
            </div>
          </div>
          <div class="chart-body">
            <canvas #statusPieChart></canvas>
          </div>
        </div>

        <!-- Delivery Volume by Area -->
        <div class="chart-card medium">
          <div class="chart-header">
            <div>
              <div class="chart-title">Delivery Volume by Area</div>
              <div class="chart-subtitle">Orders per delivery zone</div>
            </div>
          </div>
          <div class="chart-body">
            <canvas #deliveryAreaBarChart></canvas>
          </div>
        </div>

        <!-- Delivery Performance -->
        <div class="chart-card medium">
          <div class="chart-header">
            <div>
              <div class="chart-title">Delivery Performance</div>
              <div class="chart-subtitle">On-time vs delayed deliveries</div>
            </div>
          </div>
          <div class="chart-body">
            <canvas #performanceDoughnutChart></canvas>
          </div>
        </div>

        <!-- Peak Performance Hourly -->
        <div class="chart-card medium">
          <div class="chart-header">
            <div>
              <div class="chart-title">Peak Performance</div>
              <div class="chart-subtitle">Busiest hours for delivery volume</div>
            </div>
          </div>
          <div class="chart-body">
            <canvas #hourlyPerformanceChart></canvas>
          </div>
        </div>

        <!-- Delivery Time Distribution -->
        <div class="chart-card medium">
          <div class="chart-header">
            <div>
              <div class="chart-title">Delivery Time Distribution</div>
              <div class="chart-subtitle">Quality control & outlier detection</div>
            </div>
          </div>
          <div class="chart-body">
            <canvas #deliveryTimeDistChart></canvas>
          </div>
        </div>

        <!-- Volume Forecasting -->
        <div class="chart-card large">
          <div class="chart-header">
            <div>
              <div class="chart-title">Volume Forecasting (Smart Projection)</div>
              <div class="chart-subtitle">Predicted volume for the next 7 days based on current trend</div>
            </div>
          </div>
          <div class="chart-body">
            <canvas #volumeForecastChart></canvas>
          </div>
        </div>

        <!-- Top Drivers -->
        <div class="chart-card full">
          <div class="chart-header">
            <div>
              <div class="chart-title">Top Performing Drivers</div>
              <div class="chart-subtitle">Ranked by completed deliveries this month</div>
            </div>
          </div>
          <table class="data-table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Driver Name</th>
                <th>Deliveries</th>
                <th>Success Rate</th>
                <th>Avg Del Time</th>
                <th>Total Distance</th>
                <th>Rating</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let driver of drivers">
                <td>
                  <div class="rank" [class.top]="driver.rank <= 3">{{driver.rank}}</div>
                </td>
                <td class="driver-name-cell">{{driver.name}}</td>
                <td>{{driver.deliveries}}</td>
                <td><span class="success-rate-val">{{driver.successRate}}%</span></td>
                <td>{{driver.avgTime}} min</td>
                <td class="distance-val">{{driver.distance}} km</td>
                <td><span class="rating-star">★</span> {{driver.rating}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <ng-template #chartsSkeleton>
        <!-- Large Chart Skeleton -->
        <div class="chart-card large">
            <div class="skeleton-chart-header">
                <div class="skeleton-block skeleton-chart-title"></div>
                <div class="skeleton-block skeleton-chart-subtitle"></div>
            </div>
            <div class="skeleton-block skeleton-chart-placeholder" style="height: 350px;"></div>
        </div>

        <!-- Small Chart Skeleton -->
        <div class="chart-card small">
            <div class="skeleton-chart-header">
                <div class="skeleton-block skeleton-chart-title"></div>
                <div class="skeleton-block skeleton-chart-subtitle"></div>
            </div>
            <div class="skeleton-block skeleton-chart-placeholder" style="height: 180px;"></div>
        </div>

        <!-- Medium Chart Skeletons -->
        <div class="chart-card medium" *ngFor="let i of [1,2,3,4]">
            <div class="skeleton-chart-header">
                <div class="skeleton-block skeleton-chart-title"></div>
                <div class="skeleton-block skeleton-chart-subtitle"></div>
            </div>
            <div class="skeleton-block skeleton-chart-placeholder"></div>
        </div>

        <!-- Forecast Chart Skeleton (Large) -->
        <div class="chart-card large">
            <div class="skeleton-chart-header">
                <div class="skeleton-block skeleton-chart-title"></div>
                <div class="skeleton-block skeleton-chart-subtitle"></div>
            </div>
            <div class="skeleton-block skeleton-chart-placeholder"></div>
        </div>

        <!-- Table Skeleton (Full) -->
        <div class="chart-card full">
            <div class="skeleton-chart-header">
                <div class="skeleton-block skeleton-chart-title"></div>
                <div class="skeleton-block skeleton-chart-subtitle"></div>
            </div>
            <div class="skeleton-table-row" *ngFor="let i of [1,2,3,4,5]">
                <div class="skeleton-block skeleton-td skeleton-td-rank"></div>
                <div class="skeleton-block skeleton-td skeleton-td-name"></div>
                <div class="skeleton-block skeleton-td skeleton-td-val"></div>
                <div class="skeleton-block skeleton-td skeleton-td-val"></div>
                <div class="skeleton-block skeleton-td skeleton-td-val"></div>
                <div class="skeleton-block skeleton-td skeleton-td-val"></div>
                <div class="skeleton-block skeleton-td skeleton-td-star"></div>
            </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>